import { render, staticRenderFns } from "./IconsHeader.vue?vue&type=template&id=2015a7b4&scoped=true&"
import script from "./IconsHeader.vue?vue&type=script&lang=js&"
export * from "./IconsHeader.vue?vue&type=script&lang=js&"
import style0 from "./IconsHeader.vue?vue&type=style&index=0&id=2015a7b4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2015a7b4",
  null
  
)

export default component.exports